var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M32,8 C25.05236,8 19.4,13.6775937 19.4,20.65625 C19.4,27.6349063 25.05236,33.3125 32,33.3125 C38.94764,33.3125 44.6,27.6349063 44.6,20.65625 C44.6,13.6775937 38.94764,8 32,8 Z M47.6768267,41.5807813 C44.2272267,38.0625312 39.6541733,36.125 34.8,36.125 L29.2,36.125 C24.34592,36.125 19.7727733,38.0625313 16.3231733,41.5807813 C12.8904667,45.0817812 11,49.7030938 11,54.59375 C11,55.370375 11.6268267,56 12.4,56 L51.6,56 C52.3731733,56 53,55.370375 53,54.59375 C53,49.7030938 51.1095333,45.0817812 47.6768267,41.5807813 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.01170c5af94d54cf3d3d28079cb91fd5.svg";
export { ForwardRef as ReactComponent };